import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

export default function DashboardPage() {
  const { token, user } = useContext(AuthContext);
  const [metrics, setMetrics] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalRevenue: 0,
    lowStockCount: 0,
  });
  useEffect(() => {
    async function loadDashboardData() {
      if (!token) return;
      try {
        const metRes = await fetch('/api/admin/metrics', { headers: { 'x-auth-token': token } });

        if (metRes.ok) setMetrics(await metRes.json());
      } catch (err) {
        console.error('Failed to load admin dashboard:', err);
      }
    }
    loadDashboardData();
  }, [token]);

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="brand-font m-0">Store Dashboard</h2>
          <span className="text-muted small">
            Welcome back, {user?.name || user?.email}! Role: <strong>{user?.role?.toUpperCase()}</strong>
          </span>
        </div>
      </div>

      {/* Metrics Row */}
      <div className="row g-4 mb-4">
        <div className="col-12 col-sm-6 col-xl-3">
          <div className="p-4 border rounded bg-card shadow-sm text-center">
            <span className="fs-1">🛍️</span>
            <h3 className="brand-font my-1">{metrics.totalProducts}</h3>
            <span className="text-muted small">Total Products</span>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="p-4 border rounded bg-card shadow-sm text-center">
            <span className="fs-1">📦</span>
            <h3 className="brand-font my-1">{metrics.totalOrders}</h3>
            <span className="text-muted small">Total Orders</span>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="p-4 border rounded bg-card shadow-sm text-center">
            <span className="fs-1">💰</span>
            <h3 className="brand-font my-1 text-primary">₹{metrics.totalRevenue.toFixed(2)}</h3>
            <span className="text-muted small">Total Revenue</span>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="p-4 border rounded bg-card shadow-sm text-center">
            <span className="fs-1">⚠️</span>
            <h3 className={`brand-font my-1 ${metrics.lowStockCount > 0 ? 'text-danger' : 'text-success'}`}>
              {metrics.lowStockCount}
            </h3>
            <span className="text-muted small">Low Stock Items</span>
          </div>
        </div>
      </div>

    </div>
  );
}
